'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002422 from "./presto.-Two-Factor-Auth-View$$anon$22.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002424 from "./presto.-Two-Factor-Auth-View$$anon$24.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002426 from "./presto.-Two-Factor-Auth-View$$anon$26.js";
import * as $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002428 from "./presto.-Two-Factor-Auth-View$$anon$28.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024 from "./presto.types$-Two-Factor-Auth-Usage$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$21() {
  this.bA5 = null;
  this.bzX = null;
  this.bzY = false;
  this.bA6 = null;
  this.bA7 = false;
  this.bAa = null;
  this.bA3 = null;
  this.bA4 = false;
  this.bzZ = null;
  this.bA0 = false;
  this.bA1 = null;
  this.bA2 = false;
  this.bA8 = false;
  this.bA9 = false;
  this.bA5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bAa = "TwoFactorAuthUsage";
}
export { $c_Lpresto_TwoFactorAuthView$$anon$21 as $c_Lpresto_TwoFactorAuthView$$anon$21 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$21.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$21;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$21() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$21 as $h_Lpresto_TwoFactorAuthView$$anon$21 };
$h_Lpresto_TwoFactorAuthView$$anon$21.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.bA5;
});
$p.M = (function() {
  if ((!this.bzY)) {
    this.bzX = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bzY = true;
  }
  return this.bzX;
});
$p.O = (function() {
  if ((!this.bA7)) {
    this.bA6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bA7 = true;
  }
  return this.bA6;
});
$p.E = (function() {
  return this.bAa;
});
$p.t = (function() {
  if ((!this.bA4)) {
    this.bA3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("tfa", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("sites", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("credentials", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$())));
    this.bA4 = true;
  }
  return this.bA3;
});
$p.N = (function() {
  if ((!this.bA0)) {
    this.bzZ = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002422.$c_Lpresto_TwoFactorAuthView$$anon$22(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002424.$c_Lpresto_TwoFactorAuthView$$anon$24())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002426.$c_Lpresto_TwoFactorAuthView$$anon$26())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.bA0 = true;
  }
  return this.bzZ;
});
$p.Q = (function() {
  if ((!this.bA2)) {
    this.bA1 = new $j_presto$002e$002dTwo$002dFactor$002dAuth$002dView$0024$0024anon$002428.$c_Lpresto_TwoFactorAuthView$$anon$28();
    this.bA2 = true;
  }
  return this.bA1;
});
$p.v = (function() {
  if ((!this.bA9)) {
    this.bA8 = false;
    this.bA9 = true;
  }
  return this.bA8;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee205) => ((p) => \u03b4scrutinee205.z8(p)))($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dUsage$0024.$m_Lpresto_types$TwoFactorAuthUsage$())));
});
var $d_Lpresto_TwoFactorAuthView$$anon$21 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$21, "presto.TwoFactorAuthView$$anon$21", ({
  SE: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$21 as $d_Lpresto_TwoFactorAuthView$$anon$21 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$21.js.map
